"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = _setPrototypeOf;

var _setPrototypeOf2 = _interopRequireDefault(require("../../core-js/object/set-prototype-of"));

function _setPrototypeOf(o, p) {
  exports.default = _setPrototypeOf = _setPrototypeOf2.default || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}